import { ExtraExpensesControllerFindAll$Params } from '@klubovna/api-client';
import { ExtraIngredientExpense } from '@klubovna/api-client';

export interface ExtraExpensesState {
  expenses: ExtraIngredientExpense[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  params: ExtraExpensesControllerFindAll$Params;
  loading: boolean;
  error: string | null;
}

export const initialExtraExpensesState: ExtraExpensesState = {
  expenses: [],
  total: 0,
  page: 1,
  limit: 20,
  totalPages: 0,
  params: {
    page: 1,
    limit: 20,
  },
  loading: false,
  error: null,
};
